import { ComponentClassNames } from '../../util/classNames';
import { HighContrastEmulationClassName, HighContrastEmulationColorMap } from '../../util/styles/highContrastEmulation';
import { HighContrastSelector, memoizeFunction, mergeStyleSets } from '../../util/styling';

type HighContrastBorderClassNames = ComponentClassNames<'highContrastBorder'>;

const styles = {
  topBorder: {
    selectors: {
      [HighContrastSelector]: {
        borderTop: '1px solid WindowText',
      },
      [`.${HighContrastEmulationClassName} &`]: {
        borderTop: `1px solid ${HighContrastEmulationColorMap.windowtext}`,
      },
    },
  },

  rightBorder: {
    selectors: {
      [HighContrastSelector]: {
        borderRight: '1px solid WindowText',
      },
      [`.${HighContrastEmulationClassName} &`]: {
        borderRight: `1px solid ${HighContrastEmulationColorMap.windowtext}`,
      },
    },
  },

  bottomBorder: {
    selectors: {
      [HighContrastSelector]: {
        borderBottom: '1px solid WindowText',
      },
      [`.${HighContrastEmulationClassName} &`]: {
        borderBottom: `1px solid ${HighContrastEmulationColorMap.windowtext}`,
      },
    },
  },

  leftBorder: {
    selectors: {
      [HighContrastSelector]: {
        borderLeft: '1px solid WindowText',
      },
      [`.${HighContrastEmulationClassName} &`]: {
        borderLeft: `1px solid ${HighContrastEmulationColorMap.windowtext}`,
      },
    },
  },
};

export const getClassNames = memoizeFunction(
  (
    top: boolean,
    right: boolean,
    bottom: boolean,
    left: boolean,
    full: boolean,
    className: string | undefined
  ): HighContrastBorderClassNames => {
    const topBorderStyle = (top || full) && styles.topBorder;
    const rightBorderStyle = (right || full) && styles.rightBorder;
    const bottomBorderStyle = (bottom || full) && styles.bottomBorder;
    const leftBorderStyle = (left || full) && styles.leftBorder;

    return mergeStyleSets({
      highContrastBorder: [topBorderStyle, rightBorderStyle, bottomBorderStyle, leftBorderStyle, className],
    });
  }
);
